import { useCallback, useEffect, useState } from "react";
import { api } from "./api";
import type { Catalog } from "./types";

// Keep the visible selection while refreshing public product information.
export function useProductCatalog(enabled = true) {
  const [data, setData] = useState<Catalog | null>(null);
  const [error, setError] = useState("");
  const [tick, setTick] = useState(0);
  const reload = useCallback(() => setTick((value) => value + 1), []);
  useEffect(() => {
    if (!enabled) return;
    let controller: AbortController | undefined;
    async function refresh() {
      controller?.abort();
      const request = new AbortController();
      controller = request;
      try {
        const next = await api<Catalog>("/product-catalog?fresh=1", undefined, request.signal);
        if (!request.signal.aborted) {
          setData(next);
          setError(next.stale ? "商品信息暂未更新，当前显示上次读取的内容。" : "");
        }
      } catch (e) {
        if (!request.signal.aborted) setError((e as Error).message);
      }
    }
    const whenVisible = () => {
      if (document.visibilityState === "visible") void refresh();
    };
    void refresh();
    window.addEventListener("focus", whenVisible);
    document.addEventListener("visibilitychange", whenVisible);
    const timer = window.setInterval(whenVisible, 30000);
    return () => {
      controller?.abort();
      window.clearInterval(timer);
      window.removeEventListener("focus", whenVisible);
      document.removeEventListener("visibilitychange", whenVisible);
    };
  }, [enabled, tick]);
  return { data, error, reload, loading: enabled && !data && !error };
}
